import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/auth";
import { I18nProvider } from "@/lib/i18n";
import { PresentationProvider } from "@/lib/presentation";
import ProtectedRoute from "@/components/ProtectedRoute";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import AuthCallback from "@/pages/AuthCallback";
import PasswordResetRequestPage from "@/pages/PasswordResetRequestPage";
import PasswordResetConfirmPage from "@/pages/PasswordResetConfirmPage";
import OnboardingPage from "@/pages/OnboardingPage";
import DashboardPage from "@/pages/DashboardPage";
import LifeTreePage from "@/pages/LifeTreePage";
import VaultPage from "@/pages/VaultPage";
import TasksPage from "@/pages/TasksPage";
import EmergencyPage from "@/pages/EmergencyPage";
import FamilyPage from "@/pages/FamilyPage";
import SettingsPage from "@/pages/SettingsPage";
import TrustCardPage from "@/pages/TrustCardPage";
import EmergencyPortalPage from "@/pages/EmergencyPortalPage";
import LockConfirmationPage from "@/pages/LockConfirmationPage";
import ImpressumPage from "@/pages/ImpressumPage";
import DatenschutzPage from "@/pages/DatenschutzPage";
import SicherheitPage from "@/pages/SicherheitPage";
import LandingPage from "@/pages/landing/LandingPage";
import WaitlistDankePage from "@/pages/WaitlistDankePage";
import WaitlistUngueltigPage from "@/pages/WaitlistUngueltigPage";
import WaitlistAbmeldenPage from "@/pages/WaitlistAbmeldenPage";
import CookieBanner from "@/components/CookieBanner";

function AppRouter() {
  const location = useLocation();
  // CRITICAL: Detect OAuth callback fragment synchronously to avoid race conditions
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/passwort-vergessen" element={<PasswordResetRequestPage />} />
      <Route path="/passwort-zuruecksetzen" element={<PasswordResetConfirmPage />} />
      <Route path="/onboarding" element={
        <ProtectedRoute requireOnboarding={false}><OnboardingPage /></ProtectedRoute>
      } />
      <Route path="/dashboard" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
      <Route path="/lebensbaum" element={<ProtectedRoute><LifeTreePage /></ProtectedRoute>} />
      <Route path="/vault" element={<ProtectedRoute><VaultPage /></ProtectedRoute>} />
      <Route path="/aufgaben" element={<ProtectedRoute><TasksPage /></ProtectedRoute>} />
      <Route path="/notfall" element={<ProtectedRoute><EmergencyPage /></ProtectedRoute>} />
      <Route path="/familie" element={<ProtectedRoute><FamilyPage /></ProtectedRoute>} />
      <Route path="/vertrauenskarte" element={<ProtectedRoute><TrustCardPage /></ProtectedRoute>} />
      <Route path="/notfall-zugang/:token" element={<EmergencyPortalPage />} />
      <Route path="/karte-sperren/:token" element={<LockConfirmationPage />} />
      <Route path="/einstellungen" element={<ProtectedRoute><SettingsPage /></ProtectedRoute>} />
      <Route path="/impressum" element={<ImpressumPage />} />
      <Route path="/datenschutz" element={<DatenschutzPage />} />
      <Route path="/sicherheit" element={<SicherheitPage />} />
      <Route path="/waitlist/danke" element={<WaitlistDankePage />} />
      <Route path="/waitlist/ungueltig" element={<WaitlistUngueltigPage />} />
      <Route path="/waitlist/abmelden" element={<WaitlistAbmeldenPage />} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <I18nProvider>
          <AuthProvider>
            <PresentationProvider>
              <AppRouter />
              <CookieBanner />
              <Toaster position="top-right" richColors closeButton />
            </PresentationProvider>
          </AuthProvider>
        </I18nProvider>
      </BrowserRouter>
    </div>
  );
}
